import React from "react";
import {QuestionRenderLatex} from "../../atoms/QuestionRenderLatex";

interface QuestionRenderAnswerProps {
    answer: any
}

export default function QuestionRenderAnswer({ answer }: QuestionRenderAnswerProps) {
    return <QuestionRenderLatex renderString={answer} title={"Ответ"} renderLatex={(renderString => `Верный ответ: ${renderString}`)} />
}